import { render, staticRenderFns } from "./ExpandableSection.vue?vue&type=template&id=73d22cfc&scoped=true&"
import script from "./ExpandableSection.vue?vue&type=script&lang=js&"
export * from "./ExpandableSection.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableSection.vue?vue&type=style&index=0&id=73d22cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d22cfc",
  null
  
)

export default component.exports